"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _iconList = _interopRequireDefault(require("./iconList"));
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/hooks/useAppConfiguration"));
var __jsx = _react["default"].createElement;
var LogoIcons = function LogoIcons(props) {
  var _icon$detailIcons$lan;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var addIcon = props.addIcon,
    option = props.option,
    _props$withMarginTop = props.withMarginTop,
    withMarginTop = _props$withMarginTop === void 0 ? false : _props$withMarginTop,
    _props$largeIcon = props.largeIcon,
    largeIcon = _props$largeIcon === void 0 ? false : _props$largeIcon;
  var icon = addIcon ? _iconList["default"].find(function (method) {
    return method.type === option.id;
  }) : "";
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row"
    }
  }, icon === null || icon === void 0 ? void 0 : (_icon$detailIcons$lan = icon.detailIcons[language]) === null || _icon$detailIcons$lan === void 0 ? void 0 : _icon$detailIcons$lan.map(function (logoIcon, index) {
    return __jsx(_Box["default"], {
      key: index,
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: largeIcon ? 190 : [50, null, 60],
        mt: largeIcon ? 0 : withMarginTop ? [30, "s5"] : "s5",
        mr: "s3",
        px: largeIcon ? 0 : "s3",
        py: "s4",
        borderRadius: 3,
        backgroundColor: logoIcon.background,
        svg: {
          maxWidth: largeIcon ? 190 : 60
        }
      }
    }, logoIcon.icon);
  }));
};
var _default = LogoIcons;
exports["default"] = _default;